import React from 'react'
import {connect} from 'react-redux'

import closeAllModals from './data/actions/close_all_modals'

class ModalDirector extends React.Component {
  constructor (props) {
    super(props)

    this.closeAllModals = this.closeAllModals.bind(this)
  }

  componentDidUpdate (prevProps) {
    const {activeModals: prevActiveModals} = prevProps
    const {activeModals} = this.props

    if (prevActiveModals !== activeModals) {
      this.scrollTop()
    }
  }

  closeAllModals (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.closeAll()
  }

  scrollTop () {
    const scroller = this.refs.modalContainer

    if (scroller && scroller.scrollTop) scroller.scrollTop = 0
  }

  renderActiveModal (modal) {
    const modalType = modal.get('type')
    const ModalComponent = this.props.modalsList[modalType]

    if (ModalComponent) {
      return <ModalComponent {...modal.get('props').toObject()}/>
    }
    else {
      return false
    }
  }

  renderCloseAll () {
    if (this.props.activeModals) {
      return (
        <span className='close-modals rc-icon-close' onClick={this.closeAllModals}></span>
      )
    }
  }

  render () {
    if (!this.props.activeModals) return false
    if (this.props.activeModals.size === 0) return false

    return (
      <div className='modal-container' ref='modalContainer'>
        <div className='modal-stack'>
          {
            this.props.activeModals.map((modal) => this.renderActiveModal(modal))
          }
        </div>
        {this.renderCloseAll()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    activeModals: state.get('modals')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeAll: () => dispatch(closeAllModals())
  }
}

const ModalDirectorContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ModalDirector)

export default ModalDirectorContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/modal_director.js
 **/